import { Theme } from '@mui/material'

const useStyles = {
  loaderContainer: (theme: Theme) => ({
    margin: theme.spacing(4, 0),
    display: 'flex',
    justifyContent: 'center',
  }),
  folderItem: (theme: Theme) => ({
    margin: theme.spacing(4, 0),
  }),
  folderLink: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  folderAddress: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center',
  }),
  folderAddressIcon: (theme: Theme) => ({
    fontSize: theme.spacing(2),
    marginRight: theme.spacing(1),
  }),
}
export default useStyles
